// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"bb862a22","239":"7bee2823","455":"d45f9089","459":"3a2d00c7","977":"931d7d27"}[chunkId] + ".chunk.js";
};